import { render, staticRenderFns } from "./ListReview_person.vue?vue&type=template&id=1a89fec2&scoped=true"
import script from "./ListReview_person.vue?vue&type=script&lang=js"
export * from "./ListReview_person.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a89fec2",
  null
  
)

export default component.exports